const get_token = () => {
  const token = localStorage.getItem("token");
  return token;
};

export default get_token;